// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f95dd7aa","239":"e3992d1d","455":"a6384a31","865":"c505d3c4"}[chunkId] + ".chunk.js";
};